import React, { useState, useEffect, useRef } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";
import "./WhatsAppButton.css";

export default function WhatsAppButton() {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  const phoneNumber = "9167798781";

  const handleRedirect = (message) => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
    setOpen(false);
  };

  // ✅ CLOSE MENU ON OUTSIDE CLICK
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="whatsapp-container" ref={menuRef}>
      {open && (
        <div className="whatsapp-menu">
          <div className="whatsapp-menu-header">
            <span>WhatsApp Enquiry</span>
          </div>

          <button
            className="whatsapp-menu-item"
            onClick={() => handleRedirect("ENQUIRE ABOUT MOCK TEST")}
          >
            1. ENQUIRE ABOUT MOCK TEST
          </button>

          <button
            className="whatsapp-menu-item"
            onClick={() => handleRedirect("ENQUIRE ABOUT CPL GROUND CLASS")}
          >
            2. ENQUIRE ABOUT CPL GROUND CLASS
          </button>

          <button
            className="whatsapp-menu-item"
            onClick={() => handleRedirect("ENQUIRE ABOUT FLIGHT TRAINING")}
          >
            3. ENQUIRE ABOUT FLIGHT TRAINING
          </button>
        </div>
      )}

      {/* Floating Button */}
      <a
        href="#!"
        className="whatsapp-float"
        onClick={(e) => {
          e.preventDefault();
          setOpen(!open);
        }}
      >
        {open ? (
          <FaXmark className="whatsapp-icon" />
        ) : (
          <FaWhatsapp className="whatsapp-icon" />
        )}
      </a>
    </div>
  );
}
